var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "portal",
    { staticClass: "vue-chat", attrs: { to: "chat" } },
    [
      _vm.isVisibleOnFeatureSwitch
        ? _c("ButtonIcon", {
            staticClass: "chat-button",
            attrs: {
              iconClassName: _vm.iconChatButton,
              iconBeforeLabel: true,
              variant: "outline"
            },
            on: { click: _vm.toggleModal }
          })
        : _vm._e(),
      _vm.isModalOpen
        ? _c("div", { ref: "modal", staticClass: "chat-modal" }, [
            _c(
              "div",
              { staticClass: "chat-modal__container" },
              [
                _c(
                  "div",
                  {
                    ref: "header",
                    staticClass: "chat-modal__header",
                    on: { mousedown: _vm.onMouseDown }
                  },
                  [
                    _c("VUELogoVonly", {
                      staticClass: "chat-modal__header__logo"
                    }),
                    _c("p", { staticClass: "chat-modal__header-title" }, [
                      _vm._v(" VUE Virtual Assistant ")
                    ]),
                    _c(
                      "div",
                      { staticClass: "chat-modal__header__button-container" },
                      [
                        _c("ButtonIcon", {
                          ref: "newChat",
                          staticClass: "purge-button",
                          attrs: {
                            iconClassName: "icon-edit",
                            iconBeforeLabel: true,
                            variant: "outline",
                            disabled: !_vm.hasChatHistory,
                            title: "Start a New Chat"
                          },
                          on: { click: _vm.initChat }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "chat-modal__header__button-container" },
                      [
                        _c("ButtonIcon", {
                          staticClass: "close-button",
                          attrs: {
                            title: "Close",
                            iconClassName: _vm.iconChatButton,
                            iconBeforeLabel: true,
                            variant: "outline"
                          },
                          on: { click: _vm.toggleModal }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c("InfiniteScroller", {
                  ref: "scrollContainer",
                  staticClass: "chat-model__infinity-scroll",
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "scrollDiv",
                        fn: function() {
                          return [
                            _c("VueChatMessageList", {
                              attrs: { messages: _vm.allMessages },
                              on: { "message-list-changed": _vm.scrollToBottom }
                            })
                          ]
                        },
                        proxy: true
                      }
                    ],
                    null,
                    false,
                    3678498779
                  )
                }),
                _c("VueChatInput", {
                  staticClass: "chat-modal__input",
                  attrs: { value: _vm.search },
                  on: { submit: _vm.fetchDataMessage }
                })
              ],
              1
            )
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }